import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route } from "react-router-dom";

import queryString from "querystring";

import commentApi from "../apis/Comment.api";
import Login from "../pages/channel/user/Login";
import { setChannelUser } from "../redux/store/auth/authDuck";

const ChannelRoute = ({ component: Component, restricted, type, ...rest }) => {
	const dispatch = useDispatch();
	const setCUser = (value) => dispatch(setChannelUser(value));
	const cUser = useSelector((state) => state.auth.channelUser);
	// const user = useSelector(state => state.auth.user);
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const queryJson = queryString.parse(window.location.search?.replace("?", ""));
	// const channelId = queryJson?.id;
	const channelUserId = queryJson?.userId;
	// const whereShow = queryJson?.whereShow;

	// const accessToken = localStorage.getItem('accessToken');
	// const refreshToken = localStorage.getItem('refreshToken');

	/**
	 * true : 로그인 필요
	 * false : 로그인 불필요
	 * @type {*}
	 */
	const typeBool = reduxChannel?.[`login_${type}_menu`];

	const [cUserActive, setCUserActive] = useState(false);

	useEffect(() => {
		if (channelUserId) {
			if (!cUserActive || !cUser?.id) {
				getCUserByQueryUser();
			}
		}
	}, [queryJson, cUser, cUserActive]);

	useEffect(() => {
		if (cUser?.id) {
			getCUser();
		}
	}, [Component]);

	/**
	 * queryString -> user_id
	 * @returns {Promise<void>}
	 */
	const getCUserByQueryUser = async () => {
		const param = {
			userId: channelUserId,
		};
		const res = await commentApi.getCUserByUserId(param);
		if (res.code === 200) {
			setCUser(res.result);
		} else {
			setCUser(null);
		}
		setCUserActive(true);
	};

	/**
	 * 탈퇴된 회원일 때 라우팅 이동시 로그아웃 처리
	 * @returns {Promise<void>}
	 */
	const getCUser = async () => {
		const param = {
			userId: cUser?.id,
		};
		const res = await commentApi.getCUserByUserId(param);
		if (res.code === 200) {
			if (res.result?.withdraw_status) {
				setCUser(null);
			}
		}
	};

	// const showCondition = () => {
	//     if (typeBool) {
	//         return false;
	//     } else {
	//         if (cUser?.id !== null) {
	//             return true;
	//         } else {
	//             if (whereShow === "edit") {
	//                 return false;
	//             } else {
	//                 return true;
	//             }
	//         }
	//     }
	// }

	return (
		<Route
			{...rest}
			render={(props) =>
				!typeBool || !!cUser ? <Component {...props} /> : <Login />
			}
		/>
	);
};

export default ChannelRoute;
